<template>
  <base-section
    id="revy"
  >
    <base-section-heading title="Revy i Borensberg">
    </base-section-heading>

    <v-container>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="5"
        >
      <p>Direkt efter nyår spelar vi "Liket på fiket", en vrickad, rolig, nyskriven revy med inslag av sång.
      </p>
          <div class="text-center">
            <base-btn
              :tile="false"
              color="primary"
              :to="{ name: 'Produktioner' }"
              class="ma-2"
              rounded
            >
              Mer om Liket på fiket
            </base-btn>
          </div>


        </v-col>

        <v-col
          cols="12"
          md="2"
        >
            <base-img
              max-width="100%"
              width="230"
              :src="require(`@/assets/liket.png`)"
            />

        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionProChart',

    data: () => ({
      features: [
        ['Components', 23, '40+'],
        ['Example Pages', 3, 10],
        ['Bugfixes and Issues', true, true],
        ['Vue CLI Support', true, true],
        ['News, Project, and Pricing Pages', false, true],
        ['6 Months Free Updates', false, true],
        ['Price', 'Free', '$60'],
      ],
    }),
  }
</script>
